import {  LandingPublicLayout } from "layouts";
import publicRoutes from "./public.route";

/**
 * Generates the route configuration for the admin section of the application.
 * @param {Function} t - Translation function used for localization.
 * @returns {Array} An array with two route objects.
 * @function adminRoutes
 */
export const landingRoutes = (t) => {
  return [
    {
      element: <LandingPublicLayout />,
      children: [...publicRoutes(t)],
    }
  ];
};
